// extracted by mini-css-extract-plugin
export default {"toolbar":"Toolbar-module__toolbar--TBvFM"};